/*********************************************************
 *                  Admin liste user Ctrl
 *
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("ConsistencyScreenCtrl", ["$http", "$scope", "toastr", "ExploitationService", function ($http, $scope, toastr, ExploitationService) {
		$scope.data = {
			nonMobiitiStopAreas: [],
			nonMobiitiStopAreasStatus: "INPROGRESS",
			stopAreasWithoutOriginalStopId: [],
			stopAreasWithoutOriginalStopIdStatus: "INPROGRESS",
			stopAreasDuplicateOriginalStopId: [],
			stopAreasDuplicateOriginalStopIdStatus: "INPROGRESS",
			inconsistentStopPoints: [],
			inconsistentStopPointsStatus: "INPROGRESS",
			nonScheduledJourneys: [],
			nonScheduledJourneysStatus: "INPROGRESS",
			vehicleJourneysWithoutCalendars: [],
			outdatedVehicleJourneys: [],
			circularReferences: [],
			circularReferencesStatus: "INPROGRESS"
		};


		function addToChouetteDataToDisplay(listToFeed, objectToDisplay) {
			let displayableObject = convertToDisplayableData(objectToDisplay);
			listToFeed.push(displayableObject);
		}

		function convertToDisplayableData(objectToDisplay) {
			if (objectToDisplay == null || objectToDisplay == undefined || objectToDisplay === "") {
				return;
			}

			let newChouetteData = {};
			newChouetteData.id = objectToDisplay.id;
			newChouetteData.objectId = objectToDisplay.objectId;
			newChouetteData.areaType = objectToDisplay.area_type;
			newChouetteData.latitude = objectToDisplay.latitude;
			newChouetteData.longitude = objectToDisplay.longitude;
			newChouetteData.name = objectToDisplay.name;
			newChouetteData.originalStopId = objectToDisplay.originalStopId;
			newChouetteData.parentObjectId = objectToDisplay.commercial_object_id;
			return newChouetteData;
		}


		ExploitationService.getNonMobiitiStopAreas().then((response) => {
			$scope.data.nonMobiitiStopAreasStatus = "OK";
			const data = response.data;
			if (data !== undefined && data !== null && data != "") {
				data.forEach(element => addToChouetteDataToDisplay($scope.data.nonMobiitiStopAreas, element));
			}

		}).catch((error) => {
			toastr.error(error.data.message, "Erreur");
			$scope.data.nonMobiitiStopAreasStatus = "ERROR";
		});


		ExploitationService.getStopAreasWithoutOriginalStopId().then((response) => {
			const data = response.data;
			$scope.data.stopAreasWithoutOriginalStopIdStatus = "OK";
			if (data !== undefined && data !== null && data !== "") {
				data.forEach(element => addToChouetteDataToDisplay($scope.data.stopAreasWithoutOriginalStopId, element));
			}
		}).catch((error) => {
			toastr.error(error.data.message, "Erreur");
			$scope.data.stopAreasWithoutOriginalStopIdStatus = "ERROR";
		});


		ExploitationService.getDuplicateOriginalStopId().then((response) => {
			const data = response.data;
			$scope.data.stopAreasDuplicateOriginalStopIdStatus = "OK";
			if (data !== undefined && data !== null && data !== "") {
				data.forEach(element => addToChouetteDataToDisplay($scope.data.stopAreasDuplicateOriginalStopId, element));
			}
		}).catch((error) => {
			toastr.error(error.data.message, "Erreur");
			$scope.data.stopAreasDuplicateOriginalStopIdStatus = "ERROR";
		});


		ExploitationService.getInconsistentStopPoints().then((response) => {
			const data = response.data;
			data.forEach(element => $scope.data.inconsistentStopPoints.push(element));
			$scope.data.inconsistentStopPointsStatus = "OK";

		}).catch((error) => {
			toastr.error(error.data.message, "Erreur");
			$scope.data.inconsistentStopPointsStatus = "ERROR";
		});


		ExploitationService.getNonScheduledJourneys().then((response) => {
			$scope.data.nonScheduledJourneys = response.data;
			$scope.data.nonScheduledJourneysStatus = "OK";
			feedVehicleJourneysWithoutCalendars();
			feedOutdatedVehicleJourneys();

		}).catch((error) => {
			toastr.error(error.data.message, "Erreur");
			$scope.data.nonScheduledJourneysStatus = "ERROR";
		});

		function feedVehicleJourneysWithoutCalendars() {

			if ($scope.data.nonScheduledJourneys === null || $scope.data.nonScheduledJourneys === 'undefined' || !Array.isArray($scope.data.nonScheduledJourneys)) {
				$scope.data.vehicleJourneysWithoutCalendars = [];
				return;
			}

			$scope.data.vehicleJourneysWithoutCalendars = $scope.data.nonScheduledJourneys.filter(vehicleJourney => vehicleJourney.timetables.length === 0);
		}

		function feedOutdatedVehicleJourneys() {

			if ($scope.data.nonScheduledJourneys === null || $scope.data.nonScheduledJourneys === 'undefined' || !Array.isArray($scope.data.nonScheduledJourneys)) {
				$scope.data.outdatedVehicleJourneys = [];
				return;
			}

			$scope.data.outdatedVehicleJourneys = $scope.data.nonScheduledJourneys.filter(vehicleJourney => vehicleJourney.timetables.length > 0);
		}

		ExploitationService.getCircularReference().then((response) => {
			const data = response.data;
			$scope.data.circularReferencesStatus = "OK";
			if (data !== undefined && data !== null && data !== "") {
				data.forEach(element => addToChouetteDataToDisplay($scope.data.circularReferences, element));
			}
		}).catch(function (data) {
			toastr.error(data.message, "Erreur");
			$scope.data.circularReferencesStatus = "ERROR";
		});

	}]);

